import { Locale } from '@constants/common';
import { getLocale, isPassCheckAi } from '@utils/common';

export type BuildEndpointOptions = {
  /**
   * Prefix the path with the current locale (`/fr/graphql/ai_tool`). Off by
   * default: only endpoints whose response is translated server-side need it.
   */
  withLocale?: boolean;
};

export const getBaseUrl = (envVar?: string): string => {
  if (envVar) {
    return envVar;
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  throw new Error(
    `Environment variable is missing and window is not available. Please set the required environment variable.`
  );
};

/** `''` for English (the default site language), `/fr` | `/de` | `/es` | `/it` otherwise. */
export const getLocalePathPrefix = (locale: Locale = getLocale()): string =>
  locale === Locale.ENGLISH ? '' : `/${locale.split('-')[0]}`;

export const buildEndpoint = (
  baseUrl: string,
  path: string,
  { withLocale = false }: BuildEndpointOptions = {}
): string => {
  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const endpointPath = path.startsWith('/') ? path : `/${path}`;

  return `${base}${withLocale ? getLocalePathPrefix() : ''}${endpointPath}`;
};

/**
 * Absolute link to a policy page on the host site. Getsolved localizes these
 * routes (`/fr/subscription-policy`), Passcheck does not.
 *
 * Reads `window.siteVars` itself rather than the `PARENT_DOMAIN_LINK` export,
 * which is captured before the host page may have published the site vars.
 */
export const getPolicyUrl = (path: string): string =>
  buildEndpoint(
    getBaseUrl(window.siteVars?.REACT_APP_PARENT_DOMAIN_LINK),
    path,
    {
      withLocale: !isPassCheckAi(),
    }
  );
